import React, { useEffect } from "react";
import { useProductsContext } from "../context/ProductsContext";
import axios from "axios";
import { PRODUCTS } from "../context/actions";
import { ToastContainer, toast } from "react-toastify";
import { Button, Col, Container, Row, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const Products = () => {
  const { state, dispatch } = useProductsContext();
  const navigate = useNavigate();
  const fetchProducts = () => {
    const url = "https://fakestoreapi.com/products";
    const res = axios
      .get(url)
      .then((res) => {
        dispatch({ type: PRODUCTS.FETCH_SUCCESS, payload: res.data });
      })
      .catch((error) => {
        dispatch({ type: PRODUCTS.FETCH_ERROR, payload: error });
        toast.error(`Error : ${error}`);
      });
  };
  console.log(state.products);
  useEffect(() => {
    fetchProducts();
  }, []);
  return (
    <div>
      <Container>
        <Row>
          {state?.products?.map((product, index) => {
            return (
              <>
                <Col sm className="mt-4" key={product?.id}>
                  <Card style={{ width: "18rem" }}>
                    <Card.Img variant="top" src={product?.image} />
                    <Card.Body>
                      <Card.Title>{product?.title}</Card.Title>
                      <Card.Title>Category:{product?.category}</Card.Title>
                      <Card.Title>Price: {product?.price}</Card.Title>
                      <Card.Text>
                        {product?.description?.slice(0, 89)}
                      </Card.Text>
                      <Button
                        variant="primary"
                        onClick={() =>
                          navigate(`/apitasks/products/${product?.id}`)
                        }
                      >
                        Add to Cart
                      </Button>
                    </Card.Body>
                  </Card>
                </Col>
              </>
            );
          })}
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
};

export default Products;
